import { RubricCriteriaCanvas } from '@/components/admin/evaluation-rubrics/rubric-criteria-canvas'
import { type RubricCriterion } from '@/hooks/use-evaluation-rubrics-admin'

type RubricRequirementsCanvasProps = {
  criteria: RubricCriterion[]
  onSave: (criteria: RubricCriterion[]) => void
  onClose: () => void
}

export function RubricRequirementsCanvas({ criteria, onSave, onClose }: RubricRequirementsCanvasProps) {
  return (
    <RubricCriteriaCanvas
      criteria={criteria}
      kinds={['requirement']}
      onSave={onSave}
      onClose={onClose}
    />
  )
}
